import React from "react";
import { useNavigate } from 'react-router-dom';
import styles from "./ConditionsUtilisationPage.module.scss"; // Stellen Sie sicher, dass eine entsprechende SCSS-Datei vorhanden ist

import Footer from '../../components/Footer/Footer';

const ConditionsUtilisationPage_De = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className={styles.container}>
        <div className={styles.content}>
          <h1>Nutzungsbedingungen des Dienstes</h1>

          <hr />
          <section>
            <h2>1. Vorstellung des Dienstes</h2>
            <p>
              Die Anwendung <strong>Hatann'App</strong> ist eine interaktive Schnitzeljagd-Plattform, die es den Nutzern ermöglicht,
              Fragen basierend auf ihrem Fortschritt entlang einer definierten Route zu beantworten.
              Die Nutzung der Anwendung setzt die vollständige und uneingeschränkte Zustimmung zu diesen Nutzungsbedingungen voraus.
            </p>
          </section>

          <section>
            <h2>2. Zugang zum Dienst</h2>
            <p>
              Die Anwendung <strong>Hatann'App</strong> ist über einen Webbrowser auf einem Smartphone oder einem anderen kompatiblen Gerät zugänglich.
              Der Zugang kann bei Verbindungsverlust eingeschränkt sein, aber die Anwendung ist so konzipiert, dass sie auch im Offline-Modus eine optimale Erfahrung bietet.
            </p>
          </section>

          <section>
            <h2>3. Erstellung eines Kontos</h2>
            <p>
              Einige Funktionen von <strong>Hatann'App</strong> können die Erstellung eines Benutzerkontos erfordern.
              Bei der Registrierung verpflichtet sich der Nutzer, korrekte Informationen bereitzustellen und seine Anmeldedaten vertraulich zu behandeln.
            </p>
          </section>

          <section>
            <h2>4. Nutzung des Dienstes</h2>
            <p>Der Nutzer verpflichtet sich dazu:</p>
            <ul>
              <li><strong>Hatann'App</strong> nicht für betrügerische oder illegale Zwecke zu verwenden.</li>
              <li>Den ordnungsgemäßen Betrieb des Dienstes nicht zu stören.</li>
              <li>Andere Teilnehmer der Schnitzeljagd zu respektieren.</li>
            </ul>
          </section>

          <section>
            <h2>5. Geistiges Eigentum</h2>
            <p>
              Alle Elemente der Anwendung <strong>Hatann'App</strong>, einschließlich Inhalte, Bilder und Code, sind durch das Urheberrecht geschützt
              und dürfen ohne vorherige Genehmigung nicht reproduziert, modifiziert oder verbreitet werden.
            </p>
          </section>

          <section>
            <h2>6. Schutz personenbezogener Daten</h2>
            <p>
              <strong>Hatann'App</strong> sammelt bestimmte Daten, um die Benutzererfahrung zu verbessern. Diese Daten werden
              gemäß unserer <a className={styles.link} onClick={() => navigate("/privacy")} rel="noopener noreferrer">Datenschutzrichtlinie</a> verarbeitet.
            </p>
          </section>

          <section>
            <h2>7. Haftung</h2>
            <p>
              Der Herausgeber von <strong>Hatann'App</strong> kann nicht haftbar gemacht werden für:
            </p>
            <ul>
              <li>Fehlgebrauch des Dienstes durch den Nutzer.</li>
              <li>Technische Probleme, die außerhalb unserer Kontrolle liegen (Serverausfall, Verbindungsverlust...).</li>
              <li>Von Nutzern selbst generierte Inhalte.</li>
            </ul>
          </section>

          <section>
            <h2>8. Änderung der Bedingungen</h2>
            <p>
              Der Herausgeber behält sich das Recht vor, diese Nutzungsbedingungen jederzeit zu ändern.
              Nutzer werden über Updates über <strong>Hatann'App</strong> informiert.
            </p>
          </section>

          <section>
            <h2>9. Kontakt</h2>
            <p>
              Bei Fragen zu diesen Bedingungen können Sie uns unter folgender Adresse kontaktieren:&nbsp; 
              <a className={styles.link} href="mailto:contact@hatanna-editions.fr">contact@hatanna-editions.fr</a>
            </p>
          </section>

          <section>
            <h2>10. Entwicklung</h2>
            <p>
              Diese Anwendung wurde von <strong>Scriptales SAS</strong> entwickelt
              (<a className={styles.link} href="https://scriptales.fr" target="_blank" rel="noopener noreferrer">scriptales.fr</a>).
            </p>
          </section>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ConditionsUtilisationPage_De;
